import type { CodeListItem } from "Models/ICodeListDto";
import type { RootStateType } from "State/Store";
import { useMemo } from "react";
import { useSelector } from "react-redux";

export const useAppProductsList = () => {
  const products =
    useSelector((s: RootStateType) => s.codeList.codeLists?.products) ?? [];

  const codeListProducts = useMemo<Array<CodeListItem>>(
    () => products?.map(({ code, name }) => ({ code, name })) ?? [],
    [products],
  );

  return { products, codeListProducts };
};
